import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Card, Button, Form, Alert, Spinner } from "react-bootstrap";
import { BsEmojiAngry, BsEmojiFrown, BsEmojiNeutral, BsEmojiSmile, BsEmojiLaughing } from "react-icons/bs";
import { saveSurveyThunk } from '../store/slices/survey/surveyThunks';
import './style.css';
import logo from '../assets/imgs/logotipo.jpg';


const Survey = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [formState, setFormState] = useState({
        operativeShiftId: '',
        companyId: '',
        branchOfficeId: '',
        surveyAnswer: '',
        surveyObservations: '',
    });
    const [error, setError] = useState(null);

    const faces = [
        { value: 1, label: "1", sublabel: "Muy insatisfecho/a", bg: "#ef4444", fg: "#ffffff", Icon: BsEmojiAngry },
        { value: 2, label: "2", sublabel: "Insatisfecho/a", bg: "#f59e0b", fg: "#ffffff", Icon: BsEmojiFrown },
        { value: 3, label: "3", sublabel: "Neutral", bg: "#facc15", fg: "#1f2937", Icon: BsEmojiNeutral },
        { value: 4, label: "4", sublabel: "Satisfecho/a", bg: "#84cc16", fg: "#09300f", Icon: BsEmojiSmile },
        { value: 5, label: "5", sublabel: "Muy satisfecho/a", bg: "#22c55e", fg: "#09300f", Icon: BsEmojiLaughing },
    ];

    const { loading, surveyProcessResponse, errorsResponse } = useSelector(state => state.survey);

    const reload = () => {
        window.location.reload();
    }

    useEffect(() => {
        console.log('location', location);
        if (location.pathname === '/encuesta-satisfaccion/' && location.search !== '') {
            const { search } = location;
            const operativeData = search.split('?', 2)[1];
            const { operativeShiftId = '', companyId = '', branchOfficeId = '' } =
                Object.fromEntries(new URLSearchParams(operativeData));
            setFormState({
                ...formState,
                operativeShiftId,
                companyId,
                branchOfficeId,
            });
        } else {
            navigate('/error')
        }
    }, [location]);

    const getScore = (value) => {
        setFormState({
            ...formState,
            surveyAnswer: value,
        });
    }

    const getComments = (e) => {
        setFormState({
            ...formState,
            surveyObservations: e.target.value,
        })
    }

    const submit = (e) => {
        e.preventDefault();
        if (formState.surveyAnswer === '') {
            setError("Debes calificar para poder guardar");
            return;
        }
        setError(false);
        dispatch(saveSurveyThunk(formState));
    }

    if (!loading && errorsResponse) {
        return (
            <Container className="py-4">
                <Row className="justify-content-center">
                    <Col xs={12} md={8} lg={6}>
                        <Card className="shadow-sm">
                            <Card.Body className="text-center">
                                <h4 className="mb-3">¡Hubo un error!</h4>
                                <Button type='button' onClick={reload} size="lg">Recargar Encuesta</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    if (!loading && surveyProcessResponse) {
        return (
            <Container className="py-4">
                <Row className="justify-content-center">
                    <Col xs={12} md={8} lg={6}>
                        <Card className="shadow-sm">
                            <Card.Body className="text-center">
                                <h4 className="mb-2">¡Gracias por tu respuesta! 💙</h4>
                                <p className="text-muted mb-0">Tu opinión nos ayuda a mejorar los operativos.</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
    return (
        <Container className="py-4">
            <Row className='text-center m-auto justify-content-center'>
                <Col xs={12} md={10} lg={8} xl={6} className='text-center'>
                    <img src={logo} className='img-width'></img>
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8} xl={6}>
                    <Card className="shadow-sm">
                        <Card.Body className="p-3 p-sm-4">
                            <h3 className="text-center h4 h-sm-3">
                                ¿Cómo estuvo tu experiencia en el operativo?
                            </h3>
                            <p className="text-muted text-center mb-4 mb-5">
                                Califica con una nota de <strong>1 a 5</strong>. Donde <strong>1</strong> es que no te gustó para nada y <strong>5</strong> que estuvo excelente.
                            </p>

                            <Row className="g-2 g-sm-3 row-cols-3 row-cols-sm-5 mb-3 mb-sm-4">
                                {faces.map((f) => {
                                    const active = formState.surveyAnswer === f.value;
                                    const Icon = f.Icon;

                                    return (
                                        <Col key={f.value}>
                                            <div className={`ratio ratio-1x1 survey-tile ${active ? 'is-active' : ''}`}>
                                                <Button
                                                    variant="light"
                                                    onClick={() => getScore(f.value)}
                                                    aria-pressed={active}
                                                    className="survey-btn w-100 h-100 d-flex flex-column justify-content-between align-items-center p-2"
                                                    style={{ border: 0, borderRadius: 0 }}
                                                >
                                                    <div
                                                        className="mx-auto mb-1 d-flex align-items-center justify-content-center"
                                                        style={{ padding: 10, borderRadius: 9999, background: f.bg, color: f.fg }}
                                                    >
                                                        <Icon size={28} aria-hidden="true" />
                                                    </div>
                                                    <div className="fw-semibold lh-1">{f.label}</div>
                                                    <div className="small small-ss text-muted text-center">{f.sublabel}</div>
                                                </Button>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>


                            <Form onSubmit={submit}>
                                <Form.Group className="mb-2">
                                    <Form.Label className="mb-1 mt-3">
                                        Escribe acá tus comentarios. <span className="text-muted">(opcional)</span>
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        maxLength={1000}
                                        placeholder="Cuéntanos qué te gustó o qué deberíamos mejorar…"
                                        value={formState.surveyObservations}
                                        onChange={getComments}
                                    />
                                    <div className="text-end small text-muted mt-1">
                                        {formState.surveyObservations.length}/1000
                                    </div>
                                </Form.Group>

                                {error && (
                                    <Alert variant="danger" className="mt-3">
                                        {error}
                                    </Alert>
                                )}

                                <div className="d-grid mt-3">
                                    <Button type='submit' disabled={loading ? true : false} size="lg">
                                        {loading ? (<><Spinner size="sm" className="me-2" /> Enviando…</>) : "Enviar"}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Survey;